export default __webpack_public_path__ + "static/media/oscer-pres-neck-lump.79901ef4.svg";